import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import classnames from 'classnames';
import TransportPage from '../../views/TransportPage/';
const GLOBAL = require('../../Globals');

class Allocation extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			acyear : '',
			rcode : '',
			destin : '',
			utype : '',
			cls : '',
			section : '',
			value : '',
			depart : '',
			employee : '',
			sdate : '',
			edate : '',
			_message : '',
			alertClass :'',
			accyear : [],
			rcod : [],
			de : [],
			posts : [],
			secs : [],
			stud : [],
			dept : [],
			employ : [],
			ustype : '',
			data: [],
			edata : [],
		   _redirect : false,
		   activeTab: '1'
		}
		
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onClick = this.onClick.bind(this);
		this.toggle = this.toggle.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("transform").reset();
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.rcode && this.state.utype){
			$("#showLoader").show();
			PostData('transport/addallocation',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Transport Allocation Added Successfully!..',
						alertClass:'alert alert-success',
					});
					this.state = this.basestate;
					this.getdata();
					this.getedata();
				}
				else{
			
					this.setState({
						_message:'Already Allocate..',
						alertClass:'alert alert-danger'
					});
					this.state = this.basestate;
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('transport/deleteallocate',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Transport Allocation Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
					this.getedata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Transport Allocation',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getroutecode();
		this.getdestination();
		this.getclass();
		this.getdepartment();
		this.getdata();
		this.getedata();
		this.getacyear();
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	/** get Transport Allocation Details by Student **/
	getdata(){
		$("#showLoader").show();
		GetData('transport/gettransalloc').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	/** get Transport Allocation Details by Employee **/
	getedata(){
		$("#showLoader").show();
		GetData('transport/gettransallocemp').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					edata : responseJson
				});
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					dept : responseJson
				});
			}
		});	  
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Destination **/
	getdestination(){
		
		GetData('transport/getdestination').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					de : responseJson
				});
			}
		});
	}	
	
	/** get Route **/
	getroutecode(){
		
		GetData('transport/getroute').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					rcod : responseJson
				});
			}
		});
	}
	
  render() {
	
	var acyear = this.state.accyear;
	var rc = this.state.rcod;
	var des = this.state.de;
	var items = this.state.posts;
	var dep = this.state.dept;
	var emp = this.state.employ;
	
	/** set type select box **/
	this.type = [
		{value : '', name : 'Select'},
		{value : 'Student', name : 'Student'},
		{value : 'Employee', name : 'Employee'}
	];
	
	  /** map Subject value to react multi select **/
	var val = this.state.stud.map(function(e,key) {
	   return (
		 {value : e.id, label : e.stdname}
	   );
	});
	
	/** get Destination By Route **/
	$("#rou").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'transport/getdesbyroute/'+fr,function(o){
			$("#showLoader").hide();
			//$("#acHead").removeClass('chosen_a');
			$("#des").html('');
			$('#des')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Destination- ')); 
			$.each(o,function(key,value){			
				   $('#des')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.pickanddrop)); 	
										
			});	
		},'json');
	
	});
	
	 /** get Employee By Department **/
	$("#deprt").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'employee/getempbydept/'+fr,function(o){
			$("#showLoader").hide();
			//$("#acHead").removeClass('chosen_a');
			$("#empl").html('');
			$('#empl')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Employee- ')); 
			$.each(o,function(key,value){			
				   $('#empl')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.empname)); 	
										
			});	
		},'json');
	
	});
	
	/** get Section By Class **/
		$("#clas").change(function(){
			var fr = $(this).val();
			var ar = $("#year").val();
			$("#showLoader").show();
			$.get(GLOBAL.BASE_URL+'section/getsecbyclass/'+ar+'/'+fr,function(o){
				$("#showLoader").hide();
				$("#secs").html('');
				$('#secs')
					.append($("<option></option>")
					.attr("value",'')
					.text(' -Select Section- ')); 
				$.each(o,function(key,value){			
					   $('#secs')
						.append($("<option></option>")
						.attr("value",value.id)
						.text(value.secs)); 	
											
				});	
				
			},'json');
		
		});
	/** get Student By Class & Section **/
		GetData('student/getstdbysecandcls/'+this.state.cls+'/'+this.state.section).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					stud : responseJson
				});
			}
		}); 
	
	if(this.state.utype == 'Student'){
		
		$("#std").show(1000);
	}
	else{
		
		$("#std").hide(1000);
	}
	
	if(this.state.utype == 'Employee'){
		
		$("#emp").show(1000);
	}
	else{
		
		$("#emp").hide(1000);
	}
	
	if(this.state.ustype == 'Student'){
		
		$("#mcls").show(1000);
		$("#msec").show(1000);
		$("#mstd").show(1000);
	}
	else{
		
		$("#mcls").hide(1000);
		$("#msec").hide(1000);
		$("#mstd").hide(1000);
	}
	
	if(this.state.ustype == 'Employee'){
		
		$("#memp").show(1000);
		$("#mdep").show(1000);
	}
	else{
		
		$("#memp").hide(1000);
		$("#mdep").hide(1000);
	}
	
    return (
		<div>
		  <TransportPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				 <Row>
			  <Col md="12">
				<Nav tabs>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '1' })}
					  onClick={() => { this.toggle('1'); }}
					>
					  Transport Allocation
					</NavLink>
				  </NavItem>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '2' })}
					  onClick={() => { this.toggle('2'); }}
					>
					  Student List
					</NavLink>
				  </NavItem>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '3' })}
					  onClick={() => { this.toggle('3'); }}
					>
					  Employee List
					</NavLink>
				  </NavItem>
				</Nav>
				<TabContent activeTab={this.state.activeTab}>
				  <TabPane tabId="1">
				<Row>
				  <Col md="12">
					<Card>
					  <form action="" method="post" role="form" id="transform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader className="card-header-inner">
							<strong>Transport Allocation</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
								<option value="">Select Academic Year</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Route <span className="text-danger">*</span></Label>
								  <select name="rcode" onChange={this.onChange} className="form-control" required id="rou">
									<option value="">Select Route</option>
									{
										rc.map(function (item) {
											return <option value={item.id }>{item.startplace} - {item.stopplace}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Destination </Label>
								  <select name="desti" onChange={this.onChange} className="form-control" id="des">
									
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Type <span className="text-danger">*</span></Label>
								  <select name="utype" className="form-control" onChange={this.onChange} required>
									{this.type.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								  </select>
								</FormGroup>
							  </Col>
							  </Row>
							  <Row id="std">
								<Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
								  <select name="cls" onChange={this.onChange} className="form-control" id="clas"> 
									<option value="">Select Class</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.class}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
								  <select name="section" onChange={this.onChange} className="form-control" id="secs">
									<option value="">Select Section</option>
									
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Student <span className="text-danger">*</span></Label>
								  <Select value={this.state.value} onChange={this.handleChange} multi options={val} />
								</FormGroup>
							  </Col>
							  </Row>
							  <Row id="emp">
								<Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Department <span className="text-danger">*</span></Label>
								  <select name="depart" onChange={this.onChange} className="form-control" id="deprt"> 
									<option value="">Select Department</option>
									{
										dep.map(function (item) {
											return <option value={item.id }>{item.department}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Employee <span className="text-danger">*</span></Label>
								  <select name="employee" onChange={this.onChange} className="form-control" id="empl">
									<option value="">Select Employee</option>
									
								  </select>
								</FormGroup>
							  </Col>
							  </Row>
							  <Row>
							   <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Start Date <span className="text-danger">*</span></Label>
								  <Input type="date" name="sdate" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">End Date <span className="text-danger">*</span></Label>
								  <Input type="date" name="edate" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			   </TabPane>
			   <TabPane tabId="2">
				<Row>
				  <Col md="12">
				   <Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Route Code</th>
								<th>User Type</th>
								<th>Student Name</th>
								<th>Register No</th>
								<th width="50">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.rplace}</td>
									<td>{item.type}</td>
									<td>{item.stdname}</td>
									<td>{item.regno}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
				  </Col>
				</Row>
			   </TabPane>
			   <TabPane tabId="3">
				<Row>
				  <Col md="12">
				   <Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Route Code</th>
								<th>User Type</th>
								<th>Employee Name</th>
								<th>Employee Code</th>
								<th width="50">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.edata.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.rplace}</td>
									<td>{item.type}</td>
									<td>{item.empname}</td>
									<td>{item.empcode}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
				  </Col>
				</Row>
			   </TabPane>
			  </TabContent>
			 </Col>
			</Row>
			</div>
		</div>
	)
  }
}

export default Allocation;


// WEBPACK FOOTER //
// ./src/transport/Allocation/Allocation.js